import request from './request'

enum Api {
    applyHeader = '/loanApply/header',
    lendingHeader = '/loanLending/header'
}

/**
 * 贷款申请列表查询
 * @param params
 */
// export const loanApplyList = (params: any) => {
//     return request({ url: '/loanApply/list', method: 'post', data: params });
// };

/**
 * 贷款申请列表查询（202408 新版）
 * @param params
 */
export const loanApplyList = (params: any) => {
    return request({ url: '/loanApply/newList', method: 'post', data: params, headers: { 'Loading': true} });
};

/**
 * 贷款申请列表表头查询
 */
export const loanApplyHeader = () => {
    return request({ url: Api.applyHeader, method: 'get' });
};

/**
 * 贷款申请列表表头提交
 * @param params
 */
export const submitApplyHeader = (params: any) => {
    return request({ url: Api.applyHeader, method: 'post', data: params });
};

/**
 * 客户操作日志
 */
export const assignLog = (data: any) => {
    return request({ url: '/loanApply/assignLog/' + data?.userId + '/' + data?.applyId, method: 'get' });
};

/**
 * 贷款申请详情查询
 */
export const loanApplyDetail = (id: string) => {
    return request({ url: '/loanApply/detail/' + id, method: 'get' });
};

/**
 * 贷款申请详情查询(新)
 */
export const loanDetail = (id: string) => {
    return request({ url: '/loanApply/newDetail/' + id, method: 'get' });
};

/**
 * 贷款申请详情菜单查询
 */
export const loanDetailInfoTab = (id: string) => {
    return request({ url: '/loanApply/newDetail/infoTab/' + id, method: 'get' });
};

/**
 * 贷款申请详情 —— 经营信息
 */
export const operateInfo = (id: string) => {
    return request({ url: '/loanApply/newDetail/operateInfo/' + id, method: 'get', headers: { 'Loading': true} });
};

/**
 * 贷款申请详情 —— 商品信息
 */
export const goodsInfoPage = (data: any) => {
    return request({ url: '/loanApply/newDetail/goodsInfoPage', method: 'post', data: data });
};

/**
 * 贷款申请详情 —— 品类分布信息
 */
export const goodsTypePage = (data: any) => {
    return request({ url: '/loanApply/newDetail/goodsTypePage', method: 'post', data: data });
};

/**
 * 贷款申请详情 —— 尽调报告信息
 */
export const dutyReportList = (id: string) => {
    return request({ url: '/loanApply/newDetail/dutyReportList/' + id, method: 'get' });
};

/**
 * 贷款申请详情查询（lending）
 */
export const lendingApplyDetail = (id: string) => {
    return request({ url: '/loanApply/thirdDetail/' + id, method: 'get' });
};

/**
 * 贷款申请详情查询（202408 新版）
 */
export const loanApplyDetailNew = (id: string) => {
    return request({ url: '/loanApply/newDetail/' + id, method: 'get' });
};

/**
 * 贷款申请详情 - 查看进件二维码
 */
export const incomeCode = (data: any) => {
    return request({ url: '/loanApply/viewF04', method: 'post', params: data });
};

/**
 * 贷款申请详情 - 查看提款二维码
 */
export const disburseCode = (data: any) => {
    return request({ url: '/loanApply/viewD03', method: 'post', params: data });
};

/**
 * 贷款申请详情 - 提交终审
 */
export const submitLoanApply = (data: any) => {
    return request({ url: '/loanApply/finallySubmission', method: 'post', params: data });
};

/**
 * 贷款申请详情 - 店铺数据
 */
export const storeInfo = (id: string) => {
    return request({ url: '/loanApply/newDetail/storeInfo/' + id, method: 'get' });
};

/**
 * 贷款申请 - 关联飞书审批链接
 */
export const getApprovalWorkflowUrl = (id: string) => {
    return request({ url: '/loanApply/getApprovalWorkflowUrl/' + id, method: 'get' });
};

/**
 * 当前用户可见的贷款产品下拉框选项
 */
export const loanApplyProduct = () => {
    return request({ url: '/loanApply/product', method: 'get' });
};


/**
 * 店铺核验详情
 */
export const getVerificationDetail = (id: string) => {
    return request({ url: '/loanApply/getVerificationDetail/' + id, method: 'get' });
};

/**
 * 确认核验
 * @param params
 */
export const confirmVerification = (params: any) => {
    return request({ url: '/loanApply/confirmVerification', method: 'post', data: params });
};

/**
 * 作废申请 —— 获取作废详情
 * @param params
 */
export const cancellationDetails = (id: string) => {
    return request({ url: '/loanApply/cancellationDetails/' + id, method: 'get' });
};

/**
 * 作废申请
 * @param params
 */
export const cancelApply = (params: any) => {
    return request({ url: '/loanApply/cancelApply', method: 'post', params: params });
};

/**
 * 获取用户可进件全量店铺
 * @param params
 */
export const getStores = (data: any) => {
    return request({ url: '/loanApply/stores/' + data.userId + '/' + data.productId, method: 'get' });
};

/**
 * 修改客户进件店铺 - 贷前
 * @param params
 */
export const modifyStores = (data: any) => {
    return request({ url: '/loanApply/modifyStores', method: 'post', data: data });
};

/**
 * 修改客户进件店铺 - 贷中
 * @param params
 */
export const modifyLendingStores = (data: any) => {
    return request({ url: '/loanLending/modifyStores', method: 'post', data: data });
};

/**
 * 触发客户补录信息功能
 * @param params
 */
export const allowClientReplenish = (data: any) => {
    return request({ url: '/loanApply/allowClientReplenish', method: 'post', params: data });
};



/**
 * 授信管理列表查询
 * @param params
 */
export const loanLendingList = (params: any) => {
    return request({ url: '/loanLending/listV2', method: 'post', data: params, headers: { 'Loading': true} });
};

/**
 * 授信管理列表表头查询
 */
export const loanLendingHeader = () => {
    return request({ url: Api.lendingHeader, method: 'get' });
};

/**
 * 授信管理列表表头提交
 * @param params
 */
export const submitLendingHeader = (params: any) => {
    return request({ url: Api.lendingHeader, method: 'post', data: params });
};

/**
 * 授信管理 —— 授信管理人
 * @param params
 */
export const assignCreditManagerUser = (data: any) => {
    return request({ url: '/sys/user/assignCreditManagerUser', method: 'post', data: data });
};

/**
 * 授信管理详情查询
 */
export const lendingNewDetail = (id: string, creditId?: string) => {
    return request({ url: '/loanLending/newDetailV2/' + id, method: 'get', params: { credit_id: creditId } });
};

/**
 * 授信管理详情菜单查询
 */
export const lendingNewDetailInfoTab = (id: string, creditId: string) => {
    return request({ url: '/loanLending/newDetailV2/infoTab/' + id, method: 'get', params: { credit_id: creditId } });
};

/**
 * 授信管理详情查询 —— 修改授信额度
 */
export const updateManualThirdCreditAmount = (data: any) => {
    return request({ url: '/loanApply/updateManualThirdCreditAmount', method: 'post', data: data });
};

/**
 * 授信管理详情查询 —— 修改有效额度
 */
export const updateCreditAmount = (data: any) => {
    return request({ url: '/lend/credit/updateCreditAmount', method: 'post', data: data });
};

/**
 * 授信管理详情查询 —— 修改还款方式
 */
export const updateRepaymentMethod = (data: any) => {
    return request({ url: '/lend/credit/updateRepaymentMethod', method: 'post', data: data });
};

/**
 * 授信管理详情查询 —— 修改利率
 */
export const updateCreditRate = (data: any) => {
    return request({ url: '/lend/credit/updateCreditRate', method: 'post', data: data });
};

/**
 * 授信管理详情查询 —— 修改单日限额
 */
export const updateDailyLendLimit = (data: any) => {
    return request({ url: '/lend/credit/updateDailyLendLimit', method: 'post', data: data });
};

/**
 * 授信管理详情查询 —— 修改服务费用比例
 */
export const updateServiceFeeRatio = (data: any) => {
    return request({ url: '/lend/credit/updateServiceFeeRatio', method: 'post', data: data });
};

/**
 * 授信管理详情查询 —— 经营数据
 */
export const lendOperateInfo = (id: string, creditId: string) => {
    return request({ url: '/loanLending/newDetailV2/operateInfo/' + id, method: 'get', params: { credit_id: creditId }, headers: { 'Loading': true} });
};

/**
 * 授信管理详情查询 —— 店铺信息
 */
export const lendShopInfo = (id: string, creditId: string) => {
    return request({ url: '/loanLending/newDetailV2/storeInfo/' + id, method: 'get', params: { credit_id: creditId } });
};

/**
 * 授信管理详情查询 —— 风险监控
 */
export const lendWarnInfo = (id: string) => {
    return request({ url: '/loanApply/newDetail/warnInfo/' + id, method: 'get' });
};

/**
 * 授信管理详情查询 —— 风险监控——监控开关查询
 */
export const getWarnLevelSwitch = (data: any) => {
    return request({ url: '/loanApply/getWarnLevelSwitch', method: 'get', params: data });
};

/**
 * 授信管理详情查询 —— 风险监控——监控开关
 */
export const updateWarnLevelSwitch = (data: any) => {
    return request({ url: '/loanApply/updateWarnLevelSwitch', method: 'post', params: data });
};

/**
 * 授信管理详情查询 —— 人工回检要求 —— query
 */
export const getManualCheckRequireList = (data: any) => {
    return request({ url: '/risk/getManualCheckRequireList', method: 'post', data: data });
};

/**
 * 授信管理详情查询 —— 人工回检要求 —— add
 */
export const addManualCheckRequire = (data: any) => {
    return request({ url: '/risk/addManualCheckRequire', method: 'post', data: data });
};

/**
 * 授信管理详情查询 —— 人工回检要求 —— edit
 */
export const editManualCheckRequire = (data: any) => {
    return request({ url: '/risk/editManualCheckRequire', method: 'post', data: data });
};

/**
 * 授信管理详情查询 —— 人工回检要求 —— delete
 */
export const deleteManualCheckRequire = (data: any) => {
    return request({ url: '/risk/deleteManualCheckRequire', method: 'post', data: data });
};

/**
 * 授信管理详情查询 —— 人工回检记录 —— query
 */
export const getManualCheckRecordList = (data: any) => {
    return request({ url: '/risk/getManualCheckRecordList', method: 'post', data: data });
};

/**
 * 授信管理详情查询 —— 人工回检记录 —— add
 */
export const addManualCheckRecord = (data: any) => {
    return request({ url: '/risk/addManualCheckRecord', method: 'post', data: data });
};

/**
 * 授信管理详情查询 —— 人工回检记录 —— edit
 */
export const editManualCheckRecord = (data: any) => {
    return request({ url: '/risk/editManualCheckRecord', method: 'post', data: data });
};

/**
 * 授信管理详情查询 —— 人工回检记录 —— delete
 */
export const deleteManualCheckRecord = (data: any) => {
    return request({ url: '/risk/deleteManualCheckRecord', method: 'post', data: data });
};

/**
 * 授信管理详情 ——修改锁定店铺
 */
export const editLockMerchantCountry = (params: any) => {
    return request({ url: '/loanApply/editLockMerchantCountry', method: 'post', data: params });
};

/**
 * 授信管理详情 ——查询还款记录
 */
export const getRepaymentDetails = (params: any) => {
    return request({ url: '/repayment/getRepaymentDetails', method: 'get', params: params });
};

/**
 * 授信管理详情 ——更新授信可用额度
 */
export const synCreditAvailable = (id: string) => {
    return request({ url: '/loanLending/synCreditAvailable/' + id, method: 'get' });
};

/**
 * 授信 —— add
 * @param params
 */
export const manualCredit = (params: any) => {
    return request({ url: '/loanApply/manualCredit', method: 'post', data: params });
};

/**
 * 授信 —— view
 * @param params
 */
export const manualCreditDetails = (id: string) => {
    return request({ url: '/loanApply/manualCreditDetails/' + id, method: 'get' });
};

/**
 * 授信 —— update
 * @param params
 */
export const updateManualCredit = (params: any) => {
    return request({ url: '/loanApply/updateManualCredit', method: 'post', data: params });
};

/**
 * 授信 —— delete
 * @param params
 */
export const deleteMapping = (id: string) => {
    return request({ url: '/loanApply/deleteMapping/' + id, method: 'get' });
};

/**
 * 授信 —— 控制客户锁定权限
 * @param params
 */
export const updateEnableCollectLock = (data: any) => {
    return request({ url: '/loanApply/newDetail/updateEnableCollectLock', method: 'post', data: data });
};

/**
 * 授信 —— 五级分类 —— get
 * @param params
 */
export const getRiskFiveClass = (id: string) => {
    return request({ url: '/loanLending/getRiskFiveClass/' + id, method: 'get' });
};

/**
 * 授信 —— 五级分类 —— edit
 * @param params
 */
export const editRiskFiveClass = (data: any) => {
    return request({ url: '/loanLending/editRiskFiveClass', method: 'post', data: data });
};

/**
 * 支用 —— add
 * @param params
 */
export const manualDisbursement = (params: any) => {
    return request({ url: '/loanApply/manualDisbursement', method: 'post', data: params });
};

/**
 * 支用 —— view
 * @param params
 */
export const drawList = (id: string) => {
    return request({ url: '/loanApply/drawList/' + id, method: 'get' });
};

/**
 * 支用 —— update
 * @param params
 */
export const updateManualDisbursement = (params: any) => {
    return request({ url: '/loanApply/updateManualDisbursement', method: 'post', data: params });
};

/**
 * 支用 —— delete
 * @param params
 */
export const deleteDraw = (id: string) => {
    return request({ url: '/loanApply/deleteDraw/' + id, method: 'get' });
};

/**
 * 支用 —— 控制客户支用状态
 * @param params
 */
export const updateCreditStatus = (data: any) => {
    return request({ url: '/lend/credit/updateStatus', method: 'post', data: data });
};

/** 单笔正式授信的关闭能力及只读记录；ID保持字符串，避免大整数精度损失。 */
export interface CreditCloseState {
    credit_status: string;
    can_close: boolean;
    can_edit_credit_status: boolean;
    close_info: {
        closure_id: string;
        reason_code: string;
        reason_text: string;
        remark: string | null;
        operator_id: string;
        operator_name: string;
        closed_at: string;
    } | null;
}

/** 按正式授信ID查询；查看关闭信息不要求关闭操作权限。 */
export const creditCloseInfo = (creditId: string): Promise<{ data: CreditCloseState }> => {
    return request({ url: '/lend/credit/closeInfo', method: 'get', params: { credit_id: creditId } });
};

/** 关闭当前单笔授信；操作人、成功时间及实时准入由服务端确定。 */
export const closeCredit = (data: { credit_id: string; reason_code: string; remark: string | null }): Promise<{ data: CreditCloseState }> => {
    return request({ url: '/lend/credit/close', method: 'post', data });
};

/**
 * 支用 —— 查询还款计划
 * @param params
 */
export const queryRepayPlan = (data: any) => {
    return request({ url: '/lend/repayPlan', method: 'get', params: data });
};

/**
 * 支用 —— 添加还款计划
 * @param params
 */
export const saveRepayPlan = (data: any) => {
    return request({ url: '/lend/saveRepayPlan', method: 'post', data: data });
};

/**
 * 支用 —— 删除还款计划
 * @param params
 */
export const deleteRepayPlan = (data: any) => {
    return request({ url: '/lend/deleteRepayPlan', method: 'get', params: data });
};

/**
 * 支用 —— 查询还款明细
 * @param params
 */
export const getRepaymentByDrawId = (data: any) => {
    return request({ url: '/repayment/getRepaymentByDrawId', method: 'get', params: data });
};

/**
 * 支用 —— 添加还款明细
 * @param params
 */
export const insertRepaymentDetail = (data: any) => {
    return request({ url: '/repayment/insertRepaymentDetail', method: 'post', data: data });
};

/**
 * 担保划扣 —— view
 * @param params
 */
export const guaranteeList = (id: string) => {
    return request({ url: '/lend/guarantee/queryRecord/' + id, method: 'get' });
};

/**
 * 担保划扣 —— 查询划扣详情
 * @param params
 */
export const queryWithholdDetails = (data: any) => {
    return request({ url: '/lend/guarantee/queryWithholdDetails', method: 'get', params: data });
};

/**
 * 担保划扣 —— 设置担保费
 * @param params
 */
export const setFee = (data: any) => {
    return request({ url: '/lend/guarantee/setFee', method: 'post', data: data });
};

/**
 * 担保划扣 —— 划扣费用
 * @param params
 */
export const agmPay = (data: any) => {
    return request({ url: '/lend/guarantee/agmPay', method: 'post', data: data });
};

/**
 * 担保划扣 —— 退款费用
 * @param params
 */
export const agmRefund = (data: any) => {
    return request({ url: '/lend/guarantee/agmRefund', method: 'post', data: data });
};

/**
 * 担保划扣 —— 放款
 * @param params
 */
export const pushLendApply = (data: any) => {
    return request({ url: '/lend/pushLendApply', method: 'post', data: data });
};

/**
 * 人工 —— 推lending预锁
 * @param params
 */
export const pushAmzLendingPreLock = (data: any) => {
    return request({ url: '/loanLending/pushAmzLendingPreLock', method: 'get', params: data });
};

/**
 * 查询电子户余额
 * @param params
 */
export const getElectronAccountBalance = (data: any) => {
    return request({ url: '/loanApply/getElectronAccountBalance/' + data.userId + '/' + data.applyId, method: 'get', params: data });
};

/**
 * 授信详情 —— 额度水位线
 * @param params
 */
export const riskWaterLineMonitor = (id: string) => {
    return request({ url: '/loanLending/newDetailV2/riskWaterLineMonitor/' + id, method: 'get' });
};

/**
 * 支用管理列表
 * @param params
 */
export const loanDrawList = (data: any) => {
    return request({ url: '/loanManager/list', method: 'post', data: data });
};

/**
 * 还款流水列表
 */
export const repaymentFlowList = (data: any) => {
    return request({ url: '/repay/repaymentFlowList', method: 'post', data: data });
};

/**
 * 风险报告 —— 提交审核
 */
export const riskSubmitReview = (data: any) => {
    return request({ url: '/dutyReport/riskSubmitReview2Third', method: 'post', data: data });
};

/**
 * 风险报告 —— 审核拒绝
 */
export const riskReject = (data: any) => {
    return request({ url: '/dutyReport/riskReject2Third', method: 'post', data: data });
};

/**
 * 风险报告 —— 审核通过
 */
export const riskAdopt = (data: any) => {
    return request({ url: '/dutyReport/riskAdopt2Third', method: 'post', data: data });
};

/**
 * 风险报告 —— 审核退回初审
 */
export const riskAuditSendBack = (data: any) => {
    return request({ url: '/dutyReport/riskAuditSendBack2Third', method: 'post', data: data });
};

/**
 * 风险报告 - 删除申请记录
 */
export const deleteApply = (data: any) => {
    return request({ url: '/dutyReport/deleteApply', method: 'post', params: data });
};

/**
 * 申请详情 —— 增长趋势
 * @param params
 */
export const growthTrend = (data: any) => {
    return request({ url: '/loanApply/newDetail/growthTrend', method: 'post', data: data });
};

/**
 * 授信详情 —— 增长趋势
 * @param params
 */
export const growthTrendLending = (data: any) => {
    return request({ url: '/loanLending/newDetailV2/growthTrend', method: 'post', data: data });
};

/**
 * 申请详情 —— 经营概述详情
 * @param params
 */
export const operateSummaryDetail = (id: string) => {
    return request({ url: '/loanApply/newDetail/operateSummaryDetail/' + id, method: 'get' });
};

/**
 * 申请详情 —— 风险指标汇总
 * @param params
 */
export const riskAssessmentDetail = (id: string) => {
    return request({ url: '/loanApply/newDetail/riskAssessmentDetail/' + id, method: 'get' });
};

/**
 * 申请详情 —— 刷新重跑风险指标
 * @param params
 */
export const refreshRiskAssessment = (id: string) => {
    return request({ url: '/loanApply/newDetail/riskAssessment/refresh/' + id, method: 'post', data: {} });
};

/**
 * 授信详情 —— 经营概述详情
 * @param params
 */
export const operateSummaryDetailLending = (id: string) => {
    return request({ url: '/loanApply/newDetail/operateSummaryDetail/' + id, method: 'get' });
};

/**
 * 授信详情 —— 风险指标汇总
 * @param params
 */
export const riskAssessmentDetailLending = (id: string) => {
    return request({ url: 'loanLending/newDetailV2/riskAssessmentDetail/' + id, method: 'get' });
};
